import { deleteEventsByUser } from './api_method';

/**
 * Utility function to handle user status changes
 * If user status is changed from Active, removes all their events
 * @param userId - The user ID
 * @param newStatus - The new status being set
 * @param previousStatus - The previous status (optional, will check if it was Active)
 */
export const handleUserStatusChange = async (
    userId: string, 
    newStatus: string, 
    previousStatus?: string
) => {
    try {
        // If we have the previous status and it was Active, or if new status is not Active
        if ((previousStatus === 'Active' && newStatus !== 'Active') || 
            (!previousStatus && newStatus !== 'Active')) {
            
            // Delete all events for this user
            await deleteEventsByUser(userId);
            
            return true;
        }
        return false;
    } catch (error) {
        console.error(`Error handling user status change for user ${userId}:`, error);
        throw error;
    }
};

/**
 * Utility function to check if a user can create recurring events
 * @param userRole - The user's role
 * @returns boolean indicating if user can create recurring events
 */
export const canCreateRecurringEvents = (userRole: string): boolean => {
    return userRole === 'Super Admin' || userRole === 'Admin';
};

/**
 * Utility function to get current user details from localStorage
 * @returns User object or null if not found
 */
export const getCurrentUser = () => {
    const storedUser = localStorage.getItem("userDetails");
    return storedUser ? JSON.parse(storedUser) : null;
}; 